import React from 'react';
import {Route} from 'react-router';
import {ApplicationAuthPaths, AuthActions} from './authContstants';
import AuthHandler from './AuthHandler';


export default function AuthHandlerRoutes(props: any) {
    return <>
        <Route path={ApplicationAuthPaths.Login} render={() => <AuthHandler action={AuthActions.Login} />} />
        <Route path={ApplicationAuthPaths.LoginCallback} render={() => <AuthHandler action={AuthActions.LoginCallback} />} />
        <Route path={ApplicationAuthPaths.Profile} render={() => <AuthHandler action={AuthActions.Profile} />} />
        <Route path={ApplicationAuthPaths.LogOut} render={() => <AuthHandler action={AuthActions.Logout} />} />
        <Route path={ApplicationAuthPaths.LogOutCallback} render={() => <AuthHandler action={AuthActions.LogoutCallback} />} />
    </>;
};